module.exports = __webpack_public_path__ + "img/action-RP.eb49abc6.svg";